module.exports = {
  BACKEND_HOST: "prov-qa.inappchat.io",
  PROTOCOL: "https:",
  CHATSERVER_HOST: "socket-qa.inappchat.io",
  CHATBOT_HOST: "onewebchat-bot-qa.inappchat.io/api",
  SOCKET_SERVER_WIDGET_HOST: "onewebchat-socket-qa.inappchat.io",
  DOMAIN: "qa.inappchat.io",
  NAMESPACE_PREFIX: "qa",
  SKIP_PREFLIGHT_CHECK: true,
  CLOUD_HOSTED_ENABLED: true,
  ON_PREMISE_ENABLED: true,
  CHARGEBEE_SITE: "ripbullnetworks-test",
  CHARGEBEE_KEY: "test_0IhxZculGmzLbnkZSqTi5HP9wcddpRSo6h",
  JS_SAMPLEAPP_URL: "https://js-client-qa.inappchat.io",
  ALLOW_GOOGLE_CRAWL: "0",
  JS_SDK_FEATURE: true,
  MAGICLINK_FEATURE: false,
  MODERATION_FEATURE: true,
  GROUP_FEATURE: true,
  ANNOUNCE_FEATURE: true,
  PREFERENCE_FEATURE: true,
  ONBOARDAUTH_FEATURE: true,
  DATAEXPORT_FEATURE: true,
  ANALYTICS_FEATURE: true,
  RECAPTCHA_KEY: "6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI",
  ALGOLIA_SEARCH_KEY: "5f76359854488e7ac61e27d5a71986b4",
  ALGOLIA_APP_ID: "82V9L5XZDV",
  ALGOLIA_INDEX_NAME: "staging_inapp_data",
  KEYCLOAK_URL: "https://qa-keycloak.inappchat.io",
  USE_IDENTITY_PROVIDER: true,
  GOOGLE_CLIENT_ID:
    "879210835565-ts9gi7vpth8r4iac54g4hk200jvm2bo6.apps.googleusercontent.com",
  AUTH0_HOST: "https://auth.inappchat.io",
  AUTH0_CLIENT_ID: "GJqn7DE5VmBSNprwljqARYmb3qDXRvTT",
  AUTH0_REDIRECT_PAGE: "login",
  GA_CODE: "G-WLBVXW3LED",
  GADS_CODE: "AW-10848339214",
  SIGNUP_EVENT_ID: "oZchCO-24toDEI6K8rQo",
  BOOKING_EVENT_ID: "M-a0CMmFieEDEI6K8rQo",
  CHATBOTAUTOMATION_EVENT_ID: "wyKTCL-0geQDEI6K8rQo",
  PURCHASE_EVENT_ID: "-PIMCMutu-QDEI6K8rQo",
  CALENDLY_LINK: "https://calendly.com/ripbull/30min",
  HUBSPOT_PORTALID: "22677078",
  HUBSPOT_CONTACTSUPPORT_FORMID: "a4148693-5a9b-4601-b9ee-0482565680e2",
  HUBSPOT_CONTACTUS_FORMID: "b2c696dc-9e8f-4ccf-9703-29dbbf80912e",
  ANDROID_SDK_SAMPLE_REPO:
    "https://github.com/RipBullNetworks/Demo_App_Android",
  IOS_SDK_SAMPLE_REPO: "https://github.com/RipBullNetworks/Demo_App_iOS",
  INAPPCHAT_ONECHATBOT_S3_URL:
    "https://inappchat-1chatbot.s3.us-west-1.amazonaws.com/onewebchat.js"
};
